// Angular
import { Component, Input } from '@angular/core';
// Model
import { UIConfigStyle } from '@cv-invision/core';

@Component({
	selector: 'cv-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
	@Input() uiConfigStyle: UIConfigStyle;
	
	public today: number = Date.now();
}
